import api from '@/api/chartReport'

const state = {

}

const actions = {
  getRecruiterKpiReportData (context, params) {
    return api.getRecruiterKpiReportData(params)
  },
  createExportRecruiterKpiDataTask (context, params) {
    return api.createExportRecruiterKpiDataTask(params)
  },
  getExportRecruiterKpiTaskStatus (context, params) {
    return api.getExportRecruiterKpiTaskStatus(params)
  },
  createExportJobPostingHistoryReportTask (context, data) {
    return api.createExportJobPostingHistoryReportTask(data)
  },
  getExportJobPostingHistoryReportTaskStatus (context, params) {
    return api.getExportJobPostingHistoryReportTaskStatus(params)
  },

  createExportCompanyDataReportByTypeTask (context, data) {
    return api.createExportCompanyDataReportByTypeTask(data)
  },
  getExportCompanyDataReportByTypeTaskStatus (context, params) {
    return api.getExportCompanyDataReportByTypeTaskStatus(params)
  }
}

const mutations = {
}

const getters = {
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
